import usePartners from './usePartners';

export default usePartners;
